import { CssBaseline } from "@mui/material";
import { createTheme } from "@mui/material/styles";

// 创建Material-UI主题
const theme = createTheme({
  shape: {
    borderRadius: 4, // 全局圆角设置为4px
  },
  palette: {
    primary: {
      main: "#171717", // 主色调改为深灰色
      light: "#2d2d2d", // 浅色变体
      dark: "#000000", // 深色变体
      contrastText: "#ffffff", // 对比文字颜色
    },
    secondary: {
      main: "#666666", // 次要颜色
    },
    background: {
      default: "#ffffff", // 默认背景
      paper: "#ffffff", // 纸张背景
    },
    text: {
      primary: "#171717", // 主要文字颜色
      secondary: "#666666", // 次要文字颜色
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontSize: "2.5rem",
      fontWeight: 600,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
    },
    body2: {
      fontSize: "0.875rem",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none", // 按钮文字不大写
          borderRadius: 4, // 圆角设置为4px
          fontWeight: 600,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 4, // 输入框圆角设置为4px
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 4, // Alert圆角设置为4px
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 4, // Card圆角设置为4px
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 4, // Paper圆角设置为4px
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4, // Chip圆角设置为4px
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          borderRadius: 4, // Avatar圆角设置为4px
        },
      },
    },
  },
});

export { CssBaseline, theme };
